import clz from 'classnames';
import Link from 'next/link';
import { FunctionComponent, MouseEvent } from 'react';

import styles from './SubItemList.module.sass';
import { LinkItem } from '../types';

export interface SubItemListProps {
    items: LinkItem[];
    onClick: () => void;
}

const SubItemList: FunctionComponent<SubItemListProps> = ({ items, onClick }) => {
    // Event handlers
    const linkClicked = (disabled: boolean) => (event: MouseEvent<HTMLDivElement>) => {
        if (!disabled) onClick();
        else {
            event.preventDefault();
            event.stopPropagation();
        }
    };

    return (
        <div className={styles.subItemList}>
            {items.map(({ id, text, icon, path, description, disabled, newWin }) => {
                return (
                    <Link key={id} href={path}>
                        <div
                            className={clz(styles.itemTextContainer, {
                                [styles.disabled]: disabled,
                            })}
                            onClick={linkClicked(disabled)}
                        >
                            {icon ? <img className={styles.icon} src={icon} alt={text} /> : null}
                            <a className={styles.subItem} target={newWin ? '_blank' : '_self'}>
                                {text}
                            </a>
                        </div>
                    </Link>
                );
            })}
        </div>
    );
};

export default SubItemList;
